import { Box, Text } from '@mantine/core'

import type { BoggleCompletedRun } from '~/boggle/progress/types'

import { ALPHABET_ROWS, countRunLettersPlayed } from './runDetailsLetterCounts'

import classes from './RunDetailsLettersPlayed.module.css'

export function RunDetailsLettersPlayed({ run }: { run: BoggleCompletedRun }) {
  const counts = countRunLettersPlayed(run)
  const hasAnyPlayed = counts.size > 0

  if (!hasAnyPlayed) {
    return null
  }

  return (
    <Box data-testid="run-details-row-letters" mb={12}>
      <Box className={classes.grid}>
        {ALPHABET_ROWS.map(row => (
          <Box className={classes.row} key={row.join('')}>
            {row.map(letter => {
              const count = counts.get(letter) ?? 0
              return (
                <Box
                  className={`${classes.tile}${count === 0 ? ` ${classes.tileUnplayed}` : ''}`}
                  data-testid={`run-details-letter-${letter.toLowerCase()}`}
                  key={letter}
                >
                  <Text className={classes.letter}>{letter}</Text>
                  {count > 0 ? (
                    <Text className={classes.count}>{count}</Text>
                  ) : null}
                </Box>
              )
            })}
          </Box>
        ))}
      </Box>
    </Box>
  )
}
